import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Gift, Heart, BookHeart } from 'lucide-react';
import { Button } from './ui/button';

const GiftSection = ({ onStartClick }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="py-24 px-4 bg-white/80" data-testid="gift-section">
      <div className="max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center justify-center gap-4 mb-6">
          <Gift className="w-8 h-8 text-pink-400 float-animation" />
          <Heart className="w-8 h-8 text-purple-400 float-animation" style={{ animationDelay: '0.5s' }} />
          <BookHeart className="w-8 h-8 text-amber-400 float-animation" style={{ animationDelay: '1s' }} />
        </div>
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-5">{t('gift.title')}</h2>
        <div className="glass-effect rounded-3xl p-8 md:p-10 mb-8">
          <p className="text-base text-gray-700 mb-4 leading-relaxed">{t('gift.desc')}</p>
          <p className="text-lg font-semibold bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent">{t('gift.tagline')}</p>
        </div>
        <Button size="lg" onClick={() => navigate('/gift')} className="btn-primary text-white px-10 py-6 text-base font-semibold rounded-full border-0" data-testid="gift-start-btn">{t('gift.cta')}</Button>
      </div>
    </div>
  );
};
export default GiftSection;
